import { authApiCall } from '../auth/saga';

export const createCoupon = data => {
  const formattedData = {
    ...data,

    // CATEGORY
    ...(data.category
      ? {
          category:
            typeof data.category === 'object'
              ? data.category.id
              : data.category,
        }
      : {}),

    // SUBCATEGORIES
    ...(Array.isArray(data.subcategories)
      ? {
          subcategories: data.subcategories.map(sub =>
            typeof sub === 'object' ? sub.id : sub,
          ),
        }
      : {}),

    // cities (unchanged)
    ...(data.cities
      ? {
          cities: data.cities.map(city =>
            typeof city === 'object' ? city.id : city,
          ),
        }
      : {}),
  };

  return authApiCall({
    url: '/coupons/',
    method: 'post',
    data: formattedData,
  });
};

export const getCoupon = id =>
  authApiCall({
    url: `/coupons/${id}/`,
    method: 'get',
  });

export const editCoupon = (data, couponId) => {
  const formattedData = {
    ...data,

    // CATEGORY (support object or number)
    ...(data.category !== undefined
      ? {
          category:
            data.category && typeof data.category === 'object'
              ? data.category.id
              : data.category,
        }
      : {}),

    // SUBCATEGORIES (support objects or numbers)
    ...(Array.isArray(data.subcategories)
      ? {
          subcategories: data.subcategories
            .map(sub => (sub && typeof sub === 'object' ? sub.id : sub))
            .filter(
              v => v !== null && v !== undefined && v !== '' && v !== 'None',
            )
            .map(v => Number(v))
            .filter(n => Number.isFinite(n) && n > 0),
        }
      : {}),

    // CITIES (support objects or numbers)
    ...(Array.isArray(data.cities)
      ? {
          cities: data.cities
            .map(city => (city && typeof city === 'object' ? city.id : city))
            .filter(
              v => v !== null && v !== undefined && v !== '' && v !== 'None',
            )
            .map(v => Number(v))
            .filter(n => Number.isFinite(n) && n > 0),
        }
      : {}),
  };

  return authApiCall({
    url: `/coupons/${couponId}/`,
    method: 'patch',
    data: formattedData,
  });
};
